<template>
  <!-- NOTE (TEMPLATE) to show the dashboard of the researcher -->
  <div class="animated fadeIn">
    <Dashboard />
  </div>
</template>

<script>
import Dashboard from "../../components/Dashboard";
export default {
  components: {
    Dashboard
  }
};
</script>
